
/**
 * Fields listed here are sorted client-side**.

 * - EnergyBalance
 * - SubscriptionStatus
 * - SubscriptionEndDate
 * - MeterStatus
 
 * All other fields are sorted on the  server-side via API call.
 */

export const CLIENT_SIDE_SORTABLE_FIELDS = [
    'EnergyBalance',
    'SubscriptionStatus',
    'SubscriptionEndDate',
    'MeterStatus',
  ] 
  
  